exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".am-navbar{-ms-flex-align:center;height:45px;background-color:#574ef0;color:#fff}.am-navbar,.am-navbar-left,.am-navbar-right,.am-navbar-title{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center}.am-navbar-left,.am-navbar-right,.am-navbar-title{-webkit-box-flex:1;-ms-flex:1;flex:1;height:100%;-ms-flex-align:center}.am-navbar-left{padding-left:1.6rem;font-size:16px}.am-navbar-left-icon{margin-right:5px;display:inherit}.am-navbar-title{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:18px;white-space:nowrap}.am-navbar-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;font-size:16px;margin-right:1.6rem}.am-navbar-light{background-color:#fff;color:#574ef0}.am-navbar-light .am-navbar-title{color:#444}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-2!./node_modules/postcss-loader/lib??ref--4-3!./node_modules/less-loader/dist/cjs.js??ref--4-4!./node_modules/antd-mobile/lib/nav-bar/style/index.less
// module id = 621
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 19 21 22 23 24 25 26 28 29 30 31 32 33 34 35 36 37 38 39 41